import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ButtonLinkComponent, IconComponent, ButtonComponent } from '@mode/capra';
import { SharedUtilToastModule, ToastAnimation } from '@mode/shared/util-toast';
import { Toast } from 'ngx-toastr';

@Component({
  selector: 'mode-google-sheet-ingest-success',
  templateUrl: './google-sheet-ingest-success.component.html',
  styleUrls: ['./google-sheet-ingest-success.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [ToastAnimation],
  imports: [SharedUtilToastModule, ButtonLinkComponent, IconComponent, ButtonComponent],
  standalone: true,
})
export class GoogleSheetIngestSuccessComponent extends Toast {
  editDatasetLink = this.options.payload.editDatasetLink;

  dismissToast() {
    this.remove();
  }

  clickUseInNewReport() {
    this.toastPackage.triggerAction();
    this.dismissToast();
  }
}
